import React from 'react';

import { StyledArticles } from './Articles.styled';

import ArticleList from '../../components/ArticleList';
import Filters from '../../components/Filters';

import usePages from '../../hooks/usePages';
import useFilters from '../../hooks/useFilters';

import withPagination from '../../hoc/withPagination';

const PaginatedArticleList = withPagination(ArticleList);

const Articles = () => {
  const { loading, error, data } = usePages();
  const { completeFilterData, sorting } = useFilters();

  const filters = [
    { value: 'date-desc', text: 'Latest', type: 'sorting' },
    { value: 'date-asc', text: 'Oldest', type: 'sorting' },
    { value: 'title-asc', text: 'Title A-Z', type: 'sorting' },
    { value: '3', text: '3', type: 'pagination' },
    { value: '15', text: '15', type: 'pagination' },
    { value: '25', text: '25', type: 'pagination' },
    { value: '50', text: '50', type: 'pagination' },
  ];

  return (
    <StyledArticles>
      <Filters filters={filters} />
      <PaginatedArticleList
        data={completeFilterData(data, sorting)}
        loading={loading}
        error={error}
      />
    </StyledArticles>
  );
};

export default Articles;

